import { SkillVariant } from 'store/modules/skill-variants'
import { BasePolicy } from '../base-policy'
import { can } from '../index'
import { Skill } from 'store/modules/skills'
export class SkillVariantPolicy extends BasePolicy<SkillVariant> {
  public get edit() {
    return !!can(this.user, this.object.skill as Skill).edit
  }
}
